import { __read, __spreadArray } from "tslib";
import { getAddToToDoActions, getContentAppsInstalled, getConvertToPdfActions, } from './builtInActionUtils';
// PdfWorks and AddToTODO are currently built-in actions.
// TODO: review when actions are defined in manifest.
export var getBuiltInActions = function (appDefinitions, resourceStrings, systemUserConfig) {
    var userType = systemUserConfig.userType;
    var isConsumerGraphUser = userType === 'Consumer' &&
        systemUserConfig.featureGates.graphApiForV2ConsumerEnabled;
    if (!resourceStrings.documentActionsMenuResources ||
        !resourceStrings.documentActionsToastResources ||
        !resourceStrings.actionsInContextDialogResources ||
        systemUserConfig.deviceInfo.isEmbed // In current implementation, there is no chance that this code will be hit in embed. But we still keep this check here for future.
    ) {
        return undefined;
    }
    // Get 'Add to ToDo' action
    var builtInActions = getAddToToDoActions(resourceStrings, systemUserConfig.deviceInfo.isHwa);
    // Get 'Concvert to PDF' action
    if (systemUserConfig.featureGates.convertToPdfEnabled &&
        systemUserConfig.oneDriveEnabled &&
        (userType === 'Enterprise' || isConsumerGraphUser)) {
        // Depending on whether or not PDFWorks is installed, get the correct action to register
        // and set that action as the next action for convert!
        var pdfAppInfo = getContentAppsInstalled(appDefinitions).PdfWorks;
        var pdfActions = getConvertToPdfActions(resourceStrings, systemUserConfig.deviceInfo.isHwa, pdfAppInfo);
        if (pdfActions && pdfActions.length) {
            builtInActions.push.apply(builtInActions, __spreadArray([], __read(pdfActions), false));
        }
    }
    return builtInActions;
};
//# sourceMappingURL=getBuiltInActions.js.map